import { render, staticRenderFns } from "./ListField.vue?vue&type=template&id=b3bb74e0&scoped=true&"
import script from "./ListField.vue?vue&type=script&lang=js&"
export * from "./ListField.vue?vue&type=script&lang=js&"
import style0 from "./ListField.vue?vue&type=style&index=0&id=b3bb74e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bb74e0",
  null
  
)

export default component.exports